module.exports = __webpack_public_path__ + "img/11-about.36f84835.jpg";